import { gql, useMutation, useQuery } from "@apollo/client";
import {
  SetPhonemeFromPosition,
  SetPhonemeFromPositionVariables,
} from "./__generated__/SetPhonemeFromPosition";
import {
  UnsetPhonemeFromPosition,
  UnsetPhonemeFromPositionVariables,
} from "./__generated__/UnsetPhonemeFromPosition";
import {
  ExtractPhonemesWithRegex,
  ExtractPhonemesWithRegexVariables,
} from "./__generated__/ExtractPhonemesWithRegex";

export const useSetPhonemeFromPosition = () =>
  useMutation<SetPhonemeFromPosition, SetPhonemeFromPositionVariables>(
    gql`
      mutation SetPhonemeFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
        $kind: ExtendedPhonemeKind!
      ) {
        setPhonemeFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
          kind: $kind
        )
      }
    `,
  );

export const useUnsetPhonemeFromPosition = () =>
  useMutation<UnsetPhonemeFromPosition, UnsetPhonemeFromPositionVariables>(
    gql`
      mutation UnsetPhonemeFromPosition(
        $projectId: UUID!
        $start: Int!
        $size: Int!
        $stringVersion: Int!
      ) {
        unsetPhonemeFromPosition(
          projectId: $projectId
          start: $start
          size: $size
          stringVersion: $stringVersion
        )
      }
    `,
  );

// GraphQL query for extracting phonemes with regex
export const EXTRACT_PHONEMES_WITH_REGEX = gql`
  query ExtractPhonemesWithRegex($projectId: UUID!, $pattern: String!, $caseSensitive: Boolean!) {
    extractPhonemesWithRegex(
      projectId: $projectId
      pattern: $pattern
      caseSensitive: $caseSensitive
    ) {
      startUtf16
      endUtf16
      text
      context
      contextStartUtf16
      phonemeKind
      removePhoneme
      muting
    }
  }
`;

// Hook to use the phoneme extraction query
export function useExtractPhonemesWithRegex(
  { projectId, pattern, caseSensitive }: ExtractPhonemesWithRegexVariables,
  options: { skip?: boolean } = {},
) {
  return useQuery<ExtractPhonemesWithRegex, ExtractPhonemesWithRegexVariables>(
    EXTRACT_PHONEMES_WITH_REGEX,
    {
      variables: {
        projectId,
        pattern,
        caseSensitive,
      },
      // Skip the query if pattern is empty
      skip: options.skip || !pattern || !projectId,
      // Fetch policy - adjust as needed
      fetchPolicy: "network-only",
    },
  );
}
